import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BookOpen, Heart, Calendar, ArrowRight } from 'lucide-react';
import { useAuth } from '../../../context/AuthContext';

/**
 * Cartes-lien de l'accueil (Librairie, Don, Prière, RDV pastoral).
 * Extraites de HomeScreen pour être réutilisables : à la fois par l'accueil
 * par défaut (repli JSX) ET par les blocs « section » de la page Puck `accueil`.
 * Markup identique à l'ancien HomeScreen (aucun changement visuel).
 */

export function QuickLinkCard({ icon: Icon, iconBg, iconFill, title, subtitle, onClick }) {
  return (
    <div className="px-4 py-3 bg-pcc-bg">
      <button
        onClick={onClick}
        className="w-full rounded-2xl overflow-hidden shadow-md transition-all hover:shadow-lg bg-pcc-card border border-pcc-card-border"
      >
        <div className="flex items-center gap-4 p-5">
          <div className="w-14 h-14 rounded-2xl flex items-center justify-center flex-shrink-0" style={{ backgroundColor: iconBg }}>
            <Icon size={28} className="text-white" fill={iconFill ? 'currentColor' : 'none'} />
          </div>
          <div className="flex-1 text-left">
            <h3 className="text-lg font-bold mb-0.5 text-pcc-text">{title}</h3>
            <p className="text-sm text-pcc-text-muted">{subtitle}</p>
          </div>
          <ArrowRight size={20} className="text-pcc-text-muted" />
        </div>
      </button>
    </div>
  );
}

// Repli : chaque section lit props.title / props.text si l'éditrice les a
// saisis, sinon garde la valeur codée (accueil identique par défaut — 3.2).
export function LibrarySection({ props = {} } = {}) {
  const navigate = useNavigate();
  return (
    <QuickLinkCard icon={BookOpen} iconBg="#D97706" title={props.title || 'Librairie'}
      subtitle={props.text || 'Découvrez nos ressources et livres disponibles'} onClick={() => navigate('/library')} />
  );
}

export function GivingSection({ props = {} } = {}) {
  const navigate = useNavigate();
  return (
    <QuickLinkCard icon={Heart} iconBg="#D7A072" iconFill title={props.title || 'Donner'}
      subtitle={props.text || "Soutenir l'église par vos dons et offrandes"} onClick={() => navigate('/giving')} />
  );
}

export function PrayerSection({ props = {} } = {}) {
  const navigate = useNavigate();
  return (
    <QuickLinkCard icon={Heart} iconBg="#9398DE" title={props.title || 'Ligne de prière'}
      subtitle={props.text || 'Des personnes prient pour vous'} onClick={() => navigate('/prayer')} />
  );
}

export function PastoralRdvSection({ props = {} } = {}) {
  const navigate = useNavigate();
  const { isAuthenticated, activeRole } = useAuth();
  const member = isAuthenticated && activeRole !== 'visitor';
  return (
    <QuickLinkCard icon={Calendar} iconBg="#4E7EA9" title={props.title || 'Rendez-vous pastoral'}
      subtitle={props.text || (member ? 'Prendre rendez-vous avec votre responsable' : "Échangez avec un membre de l'équipe pastorale")}
      onClick={() => navigate(member ? '/member/appointments/new' : '/visitor/appointment-request')} />
  );
}
